export default {
  backList: 'Back to list',
  resetRobot: 'Reset robot',
  startRun: 'Start',
  subtitle: '{flow}{pickPart}{chkPart} · Order {order}',
  subtitlePick: ' · Pick station {pickSt} (seed rack {wall})',
  subtitleChk: ' · Check station {chkSt}',
  infoTitle: 'Task Info',
  kTaskNo: 'Task No.',
  kFlow: 'Flow',
  kStep: 'Current Step',
  kOrder: 'Order No.',
  kPickSt: 'Pick Station',
  kChkSt: 'Check Station',
  kPos: 'Dock Position',
  kFullBay: 'Full Bay Code',
  kFrames: 'Seed Rack Occupancy',
  kQty: 'Item Qty',
  kDevice: 'Devices',
  kCreated: 'Created',
  kProg: 'Progress',
  qtyUnit: '{n} pcs',
  framesUnit: '{n} / 36 frames',
  pickStVal: '{id} · rack {wall}',
  naFlow: '— (N/A for this flow)',
  camHead: 'Head Camera',
  camWrist: 'Wrist Camera',
  camStation: 'Station Camera',
  camFrameShelf: 'Seed rack',
  camStandby: 'Idle',
  camWorking: 'Working',
  camPaused: 'Paused',
  camDone: 'Done',
  camStop: 'Stopped',
  mapTitle: 'Map Navigation',
  mapHint: 'Live robot, racks, path and waypoints',
  mapUnpack: 'Unpacking Area',
  mapWork: 'Pick / Check Zone',
  mapShip: 'Shipping Area',
  mapShelf1: 'Rack 01',
  mapShelf2: 'Rack 02',
  mapCheck: 'Check Station',
  mapAgv: 'AGV Dock',
  mapStation: 'Station RC-01',
  mapPickQty: '{done} / {total} pcs',
  logTitle: 'Live Log',
  logTitleHistory: 'History Log',
  logClear: 'Clear',
  logEmpty: 'Waiting for job events...',
  ivTitle: 'Human Intervene',
  ivNeedConfirm: 'Needs Confirm',
  ivRecord: 'Record & Pass',
  ivNone: 'No Exception',
  ivHasError: 'Exception',
  ivOccur: 'Occurred at: {step}',
  ivRobot: 'Robot action',
  ivReport: 'Report path',
  ivRecovery: 'Recovery',
  ivFoot: 'Choose a handling mode in Exception Handling, or act from the buttons below.',
  ivSafeTip: 'Robot is running normally. Kit check passed. No human intervention needed.',
  ivWait: 'Pending confirm',
  ivWaitVal: '0 items',
  ivPickDone: 'Pick complete',
  ivPickVal: '{done} / {total} pcs',
  chainTitle: 'Robot Action Chain',
  chainHintAll: 'Single-item pick (sorting_item · steps 0–7) loops by qty, then push-basket finish (sorting_finish · steps 8–9) · blue = pick, purple = finish · status: pending / running / success / failure',
  chainHintPick: 'Pick-only: sorting_item (steps 0–7) loops by qty, then sorting_finish (steps 8–9)',
  chainHintChk: 'Check-only: pick action chain (sorting_item / sorting_finish) is hidden',
  chainHintHang: 'Exception held at {step} · task resumes after close-loop',
  chainHintResume: 'Exception closed. Task continues automatically.',
  injectPlaceholder: 'Demo: inject exception…',
  injectBtn: 'Inject',
  legendPick: 'Single-item pick (blue bar)',
  legendCheck: 'Push-basket finish (purple bar)',
  legendDone: 'Done (green)',
  legendPending: 'Pending (gray)',
  legendScroll: 'Scroll horizontally to view all steps',
  chainItemProgress: 'Item {done}/{total}',
  pickTitle: 'Pick Records',
  pickHint: 'Wave {total} SKUs · {done} put · {pending} pending',
  pickHintOff: 'Check-only task · pick records N/A',
  pickSkuDim: 'By SKU',
  pickSkuCnt: 'SKU summary',
  pickOrdDim: 'By Order',
  pickOrdCnt: 'Order summary',
  pickOffEmpty: 'This task has no pick step',
  colIdx: '#',
  colSku: 'SKU',
  colGoods: 'Goods',
  colNeedPick: 'Need',
  colDonePick: 'Put',
  colResult: 'Result',
  resultDone: 'Done',
  resultDoing: 'Picking',
  resultPending: 'Pending',
  colOrder: 'Order',
  colFrame: 'Frame',
  colNeedPut: 'Need',
  colProgBar: 'Progress',
  checkTitle: 'Check Records',
  checkHint: '{total} orders · {done} checked · {err} exception',
  checkHintOff: 'Pick-only task · check records N/A',
  checkOffEmpty: 'This task has no check step',
  checkNote: 'One order maps to one seed frame — check verifies the whole frame.',
  colNeedChk: 'Need',
  colRealChk: 'Actual',
  colJudge: 'Judge',
  colHandle: 'Handle',
  judgeOk: 'Match',
  judgeQty: 'Qty mismatch',
  judgeDoing: 'Checking',
  judgePending: 'Pending',
  handlePending: 'Pending',
  handleTitle: 'Exception Handling',
  handleHint: 'Two grades: block holds for close-loop; record traces and continues',
  hdPending: 'Pending · {name}',
  hdClosed: 'Closed · {name} ({mode})',
  hdNone: 'No pending exception',
  hdPendingCnt: 'Pending exceptions · {n}',
  gradeBlock: 'Block',
  gradeRecord: 'Record',
  ruleAction: 'Robot action',
  ruleReport: 'Report path',
  ruleRecovery: 'Recovery',
  rulePolicy: 'Policy',
  rulePolicyText: 'Do not abort the whole wave: hold the current SKU or order, keep the scene, wait for a human decision, and leave a trace. Resume from the hold point after close-loop.',
  hdItem: 'Item',
  hdStep: 'Step',
  hdTime: 'Time',
  hdDur: 'Paused',
  hdState: 'Status',
  /** Exception sub-task fields (API /zm/son_tasks) */
  excFieldId: 'Sub-task ID',
  excFieldType: 'Type',
  excFieldStatus: 'Status',
  excFieldTaskId: 'Task ID',
  excFieldOrderId: 'Order ID',
  excFieldSkuId: 'SKU',
  excFieldErrorMessage: 'Error message',
  excFieldCreateTime: 'Created at',
  excFieldUpdateTime: 'Updated at',
  excTypePick: 'Picking',
  excTypeCheck: 'Checking',
  excTypeAll: 'Full flow',
  excStatusPending: 'Pending',
  excStatusRunning: 'Running',
  excStatusDone: 'Done',
  excStatusError: 'Exception',
  statePending: 'Pending',
  stateRecord: 'Record & Pass',
  stateClosed: 'Closed · {mode}',
  stateStop: 'Stopped',
  modePlaceholder: 'Select handling mode…',
  notePlaceholder: 'Notes, e.g. short 1 pc, roll back pick',
  submitHandle: 'Submit',
  stopTask: 'Stop task',
  hdLogTitle: 'Exception Log',
  hdLogEmpty: 'No exception records',
  uvTitle: 'Unverified Pass Log',
  uvHint: 'Record-grade exceptions (unreadable product/bin code) — traceable without blocking',
  uvCnt: '{n} rows',
  uvEmpty: 'No unverified records',
  colHdTime: 'Time',
  colHdItem: 'Item',
  colHdType: 'Type',
  colHdAction: 'Robot action',
  colHdReport: 'Report path',
  colHdMode: 'Mode',
  colHdNote: 'Note',
  colHdFb: 'Feedback',
  colExcCreateTime: 'Created at',
  colExcUpdateTime: 'Updated at',
  colExcSkuId: 'SKU',
  colExcOrderId: 'Order ID',
  colExcType: 'Type',
  colExcStatus: 'Status',
  colExcErrorMessage: 'Error message',
  colExcId: 'Sub-task ID',
  colUvTime: 'Time',
  colUvType: 'Type',
  colUvBay: 'Bay',
  colUvBin: 'Bin',
  colUvReason: 'Reason',
  colUvRetry: 'Retries',
  colUvRisk: 'Risk',
  riskHigh: 'High',
  riskNormal: 'Normal',
  fbNone: 'None',
  fbOk: 'Sent',
  missing: 'Task {no} not found',
  toastReset: 'Reset command sent',
  toastNeedExc: 'Select an exception type first',
  toastInjectFlow: 'Exception not in current flow ({flow})',
  toastInject: 'Injected {name}. Close it in Exception Handling.',
  toastNeedMode: 'Select a handling mode first',
  toastHandled: 'Submitted. Task continues.',
  toastStopped: 'Task stopped',
  toastDone: 'Task complete',
  mapHang: 'Held',
  mapStop: 'Stopped',
  statusStop: 'Stopped',
}
